<div (keydown.enter)="submit()" class="flex flex-col gap-6">

  <section class="flex flex-col gap-4">
    <elcia-label [label]="'app.general' | translate"/>

    <div class="flex gap-2">
      <div class="flex-1">
        <elcia-text-input [control]="productForm.controls.nameFr" [label]="'product.name-fr' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="productForm.controls.nameNl" [label]="'product.name-nl' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="productForm.controls.nameEn" [label]="'product.name-en' | translate"/>
      </div>
    </div>

    <!-- stopPropagation lets Enter insert a newline in the textareas instead of submitting -->
    <div (keydown.enter)="$event.stopPropagation()" class="flex gap-2">
      <div class="flex-1">
        <elcia-text-area [control]="productForm.controls.descriptionFr" [label]="'product.description-fr' | translate"
                         [rows]="3"/>
      </div>
      <div class="flex-1">
        <elcia-text-area [control]="productForm.controls.descriptionNl" [label]="'product.description-nl' | translate"
                         [rows]="3"/>
      </div>
      <div class="flex-1">
        <elcia-text-area [control]="productForm.controls.descriptionEn" [label]="'product.description-en' | translate"
                         [rows]="3"/>
      </div>
    </div>

    <div class="flex gap-2">
      <div class="flex-1">
        <elcia-product-type-dropdown [control]="productForm.controls.productType" [isMulti]="false"/>
      </div>
      <div class="flex-1">
        <elcia-unit-of-measure-dropdown [control]="productForm.controls.unitOfMeasureCode"/>
      </div>
      <div class="flex-1">
        <elcia-product-frequency-dropdown [control]="productForm.controls.frequency"/>
      </div>

    </div>

    @if (productType() === ProductType.LICENCE) {
      <div class="flex gap-2">
        <div class="flex-1">
          <elcia-licence-plan-dropdown [control]="productForm.controls.licencePlanId"/>
        </div>
        <div class="flex-1"></div>
        <div class="flex-1"></div>

      </div>
    }

    @if (productType() === ProductType.FEATURE) {
      <div class="flex gap-2">
        <div class="flex-1">
          <elcia-feature-dropdown [control]="productForm.controls.featureId"/>
        </div>
        <div class="flex-1"></div>
        <div class="flex-1"></div>

      </div>
    }

    @if (productType() === ProductType.PLUGIN) {
      <div class="flex gap-2">
        <div class="flex-1">
          <elcia-plugin-dropdown [control]="productForm.controls.pluginId"/>
        </div>
        <div class="flex-1"></div>
        <div class="flex-1"></div>

      </div>
    }

  </section>

  <p-divider/>

  <section class="flex flex-col gap-4">
    <elcia-label [label]="'product.prices' | translate"/>


    <div class="flex flex-col gap-4 ">
      @for (fg of productForm.controls.pricePeriods.controls; track $index) {
        <div class="flex items-center gap-2">
          <div class="flex-1">
            <elcia-numeric-input [control]="fg.controls.price" [label]="'product.price-hourly-rate' | translate"
                                 [suffix]="'€'"/>
          </div>
          <div class="flex-1">
            <elcia-date-picker [control]="fg.controls.startDate"
                               [label]="'app.start-date' | translate"/>
          </div>
          <div class="flex-1">
            <elcia-date-picker [control]="fg.controls.endDate" [label]="'app.end-date' | translate"/>
          </div>
          <div class="w-10">
            @if (!$last) {
              <elcia-button (click)="removePricePeriod($index)" icon="delete" severity="danger" variant="text"/>
            }
          </div>
        </div>
      }
    </div>
  </section>

  <p-divider/>

  <section class="flex flex-col gap-4">
    <elcia-label [label]="'entity.legal-entities' | translate "/>
    <div class="flex flex-col gap-2">
      @for (fg of productForm.controls.legalEntityProducts.controls; track $index) {
        <div class="flex items-center gap-2">
          <div class="flex-1">
            <elcia-legal-entity-dropdown [control]="fg.controls.legalEntityId" [isMulti]="false"/>
          </div>
          <div class="flex-1">
            <elcia-accounting-account-dropdown [control]="fg.controls.accountingAccountId"/>
          </div>
          <div class="w-10">
            @if (!$last) {
              <elcia-button (click)="removeLegalEntityProduct($index)" icon="delete" severity="danger" variant="text"/>
            }
          </div>
        </div>
      }
    </div>
  </section>

</div>
